// @flow
import * as React from 'react';
import styled, { css } from 'styled-components';
import { Button } from 'primitive-components';

const StyledWrapper = styled.div`
  position: relative;
`;

const StyledList = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0;

  ${({ padRight }) => padRight && 'right: 12px;'} ${({ fadeIn }) =>
    fadeIn &&
    css`
      ${StyledWrapper}:hover &,
      ${StyledWrapper}:focus-within & {
        opacity: 1;
      }
    `};
`;

const StyledItem = styled.div`
  display: inline-block;
  margin-right: 8px;

  &:last-child {
    margin-right: 0;
  }

  button:focus {
    outline: none;
  }
`;

type FloatingActionsProps = {
  children: React.Node,
};

type FloatingActionsListProps = {
  children: React.Node,
  transition?: boolean,
  fadeIn?: boolean,
  padRight?: boolean,
};

type FloatingActionsItemProps = {
  danger?: boolean,
  icon: string,
  onClick: () => void,
  styleType?: string,
};

class FloatingActions extends React.Component<FloatingActionsProps> {
  static List(props: FloatingActionsListProps) {
    return <StyledList {...props} />;
  }

  static Item(props: FloatingActionsItemProps) {
    return (
      <StyledItem>
        <Button
          {...props}
          iconLeft={props.icon}
          onClick={props.onClick}
          size="small"
          styleType={props.styleType || 'neutral'}
          subtle
        />
      </StyledItem>
    );
  }

  render() {
    return <StyledWrapper {...this.props} />;
  }
}

FloatingActions.List.defaultProps = {
  transition: false,
  fadeIn: true,
  padRight: false,
};

export default FloatingActions;
